export {
	mapDynamicState,
	mapDynamicMutations,
	mapDynamicGetters,
	mapDynamicActions,
};

function mapDynamicState(namespaceFunc, states) {
	let result = {};
	if (typeof namespaceFunc === 'string') {
		let namespaceComputedKey = namespaceFunc;
		// eslint-disable-next-line no-invalid-this
		namespaceFunc = function() { return this[namespaceComputedKey]; };
	}

	normalizeMap(states).forEach(({
		key,
		value
	}) => {
		result[key] = function() {
			let { state } = this.$store;
			let { getters } = this.$store;
			if (namespaceFunc) {
				let namespace = normalizeNamespace(namespaceFunc.call(this));
				let module = getModuleByNamespace(this.$store, 'mapDynamicState', namespace, key);
				if (!module) {
					return undefined;
				}

				/* eslint-disable */
				state = module.context.state;
				getters = module.context.getters;
				/* eslint-enable */
			}

			if (typeof value === 'function')
				return value.call(this, state, getters);
			return state[value];
		};
		result[key].vuex = true;
	});
	return result;
}

function mapDynamicMutations(namespaceFunc, mutations) {
	let result = {};
	if (typeof namespaceFunc === 'string') {
		let namespaceComputedKey = namespaceFunc;
		// eslint-disable-next-line no-invalid-this
		namespaceFunc = function() { return this[namespaceComputedKey]; };
	}

	normalizeMap(mutations).forEach(({
		key,
		value
	}) => {
		result[key] = function(...args) {
			let { commit } = this.$store;
			if (namespaceFunc) {
				let namespace = normalizeNamespace(namespaceFunc.call(this));
				let module = getModuleByNamespace(this.$store, 'mapDynamicMutation', namespace, key);
				if (!module) {
					return undefined;
				}
				// eslint-disable-next-line prefer-destructuring
				commit = module.context.commit;
			}

			if (typeof value === 'function')
				return value.apply(this.$store, [commit].concat(args));
			return commit.apply(this.$store, [value].concat(args));
		};
	});
	return result;
}

function mapDynamicGetters(namespaceFunc, getters) {
	let result = {};
	if (typeof namespaceFunc === 'string') {
		let namespaceComputedKey = namespaceFunc;
		// eslint-disable-next-line no-invalid-this
		namespaceFunc = function() { return this[namespaceComputedKey]; };
	}

	normalizeMap(getters).forEach(({
		key,
		value
	}) => {
		result[key] = function() {
			let finalValue = value;
			if (namespaceFunc) {
				let namespace = normalizeNamespace(namespaceFunc.call(this));
				let module = getModuleByNamespace(this.$store, 'mapDynamicGetters', namespace, key);
				if (!module) {
					return undefined;
				}
				finalValue = namespace + value;
			}
			return this.$store.getters[finalValue];
		};
	});
	return result;
}

function mapDynamicActions(namespaceFunc, actions) {
	let result = {};
	if (typeof namespaceFunc === 'string') {
		let namespaceComputedKey = namespaceFunc;
		// eslint-disable-next-line no-invalid-this
		namespaceFunc = function() { return this[namespaceComputedKey]; };
	}

	normalizeMap(actions).forEach(({
		key,
		value
	}) => {
		result[key] = function(...args) {
			let { dispatch } = this.$store;
			if (namespaceFunc) {
				let namespace = normalizeNamespace(namespaceFunc.call(this));
				let module = getModuleByNamespace(this.$store, 'mapDynamicActions', namespace, key);
				if (!module) {
					return undefined;
				}
				// eslint-disable-next-line
				dispatch = module.context.dispatch;
			}
			if (typeof value === 'function')
				return value.apply(this, [ dispatch, ...args ]);
			else
				return dispatch.apply(this.$store, [ value, ...args ]);
		};
	});
	return result;
}

function normalizeMap(map) {
	if (Array.isArray(map)) {
		return map.map(key => ({
			key,
			value: key
		}));
	} else {
		return Object.keys(map).map(key => ({
			key,
			val: map[key]
		}));
	}
}

function normalizeNamespace(namespace) {
	if (Array.isArray(namespace)) {
		return `${namespace.join('/')}/`;
	} else if (namespace.charAt(namespace.length - 1) === '/') {
		return namespace;
	} else {
		return `${namespace}/`;
	}
}

function getModuleByNamespace(store, helper, namespace, key) {
	let module = store._modulesNamespaceMap[namespace];
	// eslint-disable-next-line no-undef
	if (process.env.NODE_ENV !== 'production' && !module) {
		console.error(`[vuex] module namespace not found in ${helper}(): ${namespace}, ${key}`);
	}
	return module;
}
